import React, { useState } from "react";

import { supportedChainsMap } from "../../config";
import { useNetworks } from "../../hooks";
import { CurrentChainModal } from "../CurrentChainModal/CurrentChainModal";
import "./CurrentChainButton.scss";
import { UnknownLogoIMG } from "../../assets";

export const CurrentChainButton = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const { networks } = useNetworks();

  return Object.values(networks).some((network) => network.address) ? (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setModalVisible(true);
        }}
        className="current-chain-button__container"
      >
        {Object.keys(networks)
          .filter((key) => networks[key].address)
          .map((key, index, arr) => {
            const chainData = supportedChainsMap[key][networks[key].chainId];
            let image = UnknownLogoIMG;
            let displayName = "Unknown";

            if (chainData) {
              image = chainData.image;
              displayName = chainData.displayName;
            }
            return (
              <React.Fragment key={key}>
                <img
                  className="current-chain-button__chain-image"
                  src={image}
                  alt={displayName}
                />
                {index !== arr.length - 1 && (
                  <div className="current-chain-button__vertical-separator"></div>
                )}
              </React.Fragment>
            );
          })}
      </div>

      <CurrentChainModal isOpen={modalVisible} onClose={setModalVisible} />
    </>
  ) : (
    <></>
  );
};
